import { MenuTreeResponse } from "./useNavigationMenu";

export const parseMenuTreeResponse = (data: unknown): MenuTreeResponse => {
    if (data !== null && typeof data === "object" && "tree" in data && "meta" in data) {
        return data as MenuTreeResponse;
    }

    const hydraMember =
        data !== null && typeof data === "object" && "hydra:member" in data ?
            (data as { "hydra:member"?: unknown })["hydra:member"]
        :   undefined;

    if (Array.isArray(hydraMember) && hydraMember.length > 0) {
        const first = hydraMember[0];
        if (first !== null && typeof first === "object" && "tree" in first && "meta" in first) {
            return first as MenuTreeResponse;
        }
    }

    return {
        tree: [],
        meta: {
            total_items: 0,
            max_depth: 0,
            last_updated: new Date().toISOString(),
        },
    };
};
